import { useHistory } from "react-router-dom";

export default function BackNavigate() {
    let history = useHistory();
    return (
        <>
          <button onClick={() => history.goBack()}> Back </button>
        </>
    );
};